// Thin API facade over the canonical core client. Keep surface-specific
// helpers here and shared request contracts in api-core.js.
import * as core from './api-core';
export * from './api-core';
export const getToken = core.getToken;

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

const csvCell = value => {
  if (value === null || value === undefined) return '""';
  const text = typeof value === 'object' ? JSON.stringify(value) : String(value);
  return `"${text.replace(/"/g, '""')}"`;
};

const backupToCsv = data => {
  const rows = [['Dataset', 'Record', 'Field', 'Value']];
  Object.entries(data || {}).forEach(([dataset, value]) => {
    if (Array.isArray(value)) {
      if (!value.length) rows.push([dataset, '', '', '']);
      value.forEach((record, index) => {
        if (record && typeof record === 'object' && !Array.isArray(record)) {
          Object.entries(record).forEach(([field, fieldValue]) => rows.push([dataset, index + 1, field, fieldValue]));
        } else rows.push([dataset, index + 1, 'value', record]);
      });
      return;
    }
    if (value && typeof value === 'object') {
      Object.entries(value).forEach(([field, fieldValue]) => rows.push([dataset, 1, field, fieldValue]));
      return;
    }
    rows.push([dataset, 1, 'value', value]);
  });
  return rows.map(row => row.map(csvCell).join(',')).join('\r\n');
};

export const downloadDataBackup = async businessName => {
  const data = await core.getDataBackup();
  const csv = backupToCsv(data);
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const safeName = (businessName || 'business').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase() || 'business';
  a.href = url;
  a.download = `${safeName}-backup-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Give the browser time to start consuming the Blob before revoking it.
  // Immediate revocation can make programmatic downloads appear to do nothing
  // in some browser/WebView combinations.
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};

const authHeaders = () => ({ 'x-auth-token': core.getToken() });
const parseJson = async res => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.error || 'Request failed');
    error.status = res.status;
    error.data = data;
    throw error;
  }
  return data;
};

// Brand-new raw-material catalog rows are deliberately separate from
// restocking existing materials. These endpoints never reuse /bulk.
export const bulkUploadNewRawInventory = formData =>
  fetch(`${API_BASE}/api/inventory/bulk-new`, { method: 'POST', headers: authHeaders(), body: formData }).then(parseJson);

export const downloadNewRawInventoryTemplate = () => {
  window.open(`${API_BASE}/api/inventory/new-template?token=${encodeURIComponent(core.getToken())}&fresh=${Date.now()}`, '_blank');
};

// Enterprise fixed-asset location assignment.
export const updateAssetShop = (assetId, shopId) =>
  core.requestApi('PUT', `/api/assets/${encodeURIComponent(assetId)}/shop`, { shopId: shopId || null });


// Admin outbox API kept in this facade because the cleanup branch removed
// the old admin-account exports from api-core.js while the portal still uses them.
const adminToken = () => localStorage.getItem('admin_account_token') || '';
const adminHeaders = () => ({ 'Content-Type':'application/json', Authorization:`Bearer ${adminToken()}` });
const adminReq = async (method, path, body) => {
  const res = await fetch(`${API_BASE}${path}`, { method, headers:adminHeaders(), ...(body ? { body:JSON.stringify(body) } : {}) });
  return parseJson(res);
};
export const getAdminOutbox = status => adminReq('GET', `/api/admin-portal/outbox${status && status !== 'all' ? `?status=${encodeURIComponent(status)}` : ''}`);
export const markAdminOutboxSent = id => adminReq('PUT', `/api/admin-portal/outbox/${encodeURIComponent(id)}/mark-sent`, {});
export const dismissAdminOutboxEntry = id => adminReq('PUT', `/api/admin-portal/outbox/${encodeURIComponent(id)}/dismiss`, {});
